import { getPermissions } from '@/services/permission.service';

export const getPlatformPermissions = async (backendUrlBase?: string) => {
  if (!backendUrlBase && !window.taptap) {
    return [];
  }

  return getPermissions(backendUrlBase);
};
